const PERFORMANCE = 'performance'
const SPECIFIC_COLOR = 'specific-color'
const CONDITIONAL = 'conditional'

export { PERFORMANCE, SPECIFIC_COLOR, CONDITIONAL }
